module.exports = __webpack_public_path__ + "static/media/card-email-mobile-br.5f2b7fd4.png";